import { IconNames } from '@blueprintjs/icons'
import * as React from 'react'
import { useSelector } from 'react-redux'
import SupportEmailLink from '../../components/AppError/SupportEmailLink'
import EmployeeSwitcher from '../../components/EmployeeSwitcher'
import FullScreenErrorMessage from '../../components/FullScreenErrorMessage'
import { AppState } from '../../store'

export default () => {
  const isEmployee = useSelector((s: AppState) => s.current.user.employee)

  return (
    <FullScreenErrorMessage
      iconName={IconNames.GEOSEARCH}
      title={<span>Sorry, this page does not exist.</span>}
      message={
        <>
          <span>
            If you think it should, please email <SupportEmailLink />
          </span>
          {isEmployee && <EmployeeSwitcher />}
        </>
      }
    />
  )
}
